// Testimonials data for Azur Escape
export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Johnson",
    country: "United States",
    rating: 5,
    text: "An absolutely unforgettable experience! Our guide was incredibly knowledgeable and made every stop special. The French Riviera is stunning, and this tour showcased the best of it.",
    date: "October 2024",
    tour: "Full Day French Riviera Tour",
  },
  {
    id: 2,
    name: "Marco Rossi",
    country: "Italy",
    rating: 5,
    text: "Perfect organization from start to finish. The small group size made it feel very personal, and we got to see hidden gems that most tourists miss. Highly recommended!",
    date: "September 2024",
    tour: "Cannes & Antibes Discovery",
  },
  {
    id: 3,
    name: "Emma Williams",
    country: "United Kingdom",
    rating: 5,
    text: "This was the highlight of our Mediterranean vacation! The coastal views were breathtaking, and our guide's passion for the region really showed. Worth every penny.",
    date: "August 2024",
    tour: "Monaco & Monte Carlo Luxury Tour",
  },
  {
    id: 4,
    name: "Hans Mueller",
    country: "Germany",
    rating: 5,
    text: "Exceptional service and beautiful scenery. The tour was well-paced, and we had plenty of time to explore each location. Our guide was friendly and professional.",
    date: "July 2024",
    tour: "Nice & Eze Village Tour",
  },
  {
    id: 5,
    name: "Sophie Dubois",
    country: "France",
    rating: 5,
    text: "Even as a French native, I discovered new places and stories about the Riviera. The guide was excellent, and the experience was truly memorable. Merci beaucoup!",
    date: "June 2024",
    tour: "Saint-Tropez Day Trip",
  },
  {
    id: 6,
    name: "David Chen",
    country: "Singapore",
    rating: 5,
    text: "Amazing tour with stunning views at every turn. The guide was punctual, knowledgeable, and made sure everyone was comfortable. I'd do it again in a heartbeat!",
    date: "May 2024",
    tour: "Full Day French Riviera Tour",
  },
];
